// Licensed to Elasticsearch B.V under one or more agreements.
// Elasticsearch B.V licenses this file to you under the Apache 2.0 License.
// See the LICENSE file in the project root for more information
'use strict';
/* eslint camelcase: 0 */

/* eslint no-unused-vars: 0 */

var _objectWithoutProperties = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function buildXpackLicensePost(opts) {
  // eslint-disable-next-line no-unused-vars
  var makeRequest = opts.makeRequest,
      ConfigurationError = opts.ConfigurationError,
      handleError = opts.handleError,
      snakeCaseKeys = opts.snakeCaseKeys;
  /**
   * Perform a [xpack.license.post](https://www.elastic.co/guide/en/elasticsearch/reference/6.7/update-license.html) request
   *
   * @param {boolean} acknowledge - whether the user has acknowledged acknowledge messages (default: false)
   * @param {object} body - licenses to be installed
   */

  var acceptedQuerystring = ['acknowledge'];
  var snakeCase = {};
  return function xpackLicensePost(params, options, callback) {
    options = options || {};

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    if (typeof params === 'function' || params == null) {
      callback = params;
      params = {};
      options = {};
    } // validate headers object


    if (options.headers != null && typeof options.headers !== 'object') {
      var err = new ConfigurationError("Headers should be an object, instead got: ".concat(typeof options.headers));
      return handleError(err, callback);
    }

    var warnings = [];

    var _params = params,
        method = _params.method,
        body = _params.body,
        querystring = _objectWithoutProperties(_params, ["method", "body"]);

    querystring = snakeCaseKeys(acceptedQuerystring, snakeCase, querystring, warnings);

    if (method == null) {
      method = 'PUT';
    }

    var ignore = options.ignore;

    if (typeof ignore === 'number') {
      options.ignore = [ignore];
    }

    var path = '';
    path = '/' + '_xpack' + '/' + 'license'; // build request object

    var request = {
      method: method,
      path: path,
      body: body || '',
      querystring: querystring
    };
    options.warnings = warnings.length === 0 ? null : warnings;
    return makeRequest(request, options, callback);
  };
}

module.exports = buildXpackLicensePost;